import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, TextField, Button, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';

const BrandForm = ({ selected, onSuccess, onCancel }) => {
  const [name, setName] = useState('');
  const [image, setImage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selected) {
      setName(selected.name);
      setImage(selected.image || '');
    } else {
      setName('');
      setImage('');
    }
  }, [selected]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = { 
        name,
        image
      };
      
      if (selected) {
        await axios.put(`/api/brands/${selected.id}`, data);
      } else {
        await axios.post('/api/brands', data);
      }
      onSuccess();
      setName('');
      setImage('');
    } catch (error) {
      console.error('Error saving brand:', error);
      alert('Failed to save brand');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1, 
        bgcolor: '#f57c00',
        color: 'white',
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}>
        <LocalFireDepartmentIcon sx={{ fontSize: 20 }} />
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
          {selected ? 'Edit Brand' : 'Add New Brand'}
        </Typography>
      </DialogTitle>
      
      <DialogContent dividers>
        <Box component="form" id="brand-form" onSubmit={handleSubmit} sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <TextField
            fullWidth
            value={name}
            onChange={e => setName(e.target.value)}
            label="Brand Name"
            placeholder="e.g., Nike, Adidas"
            required
            autoFocus
            sx={{ 
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#9c27b0',
                }
              }
            }}
          />

          <TextField
            fullWidth
            value={image}
            onChange={e => setImage(e.target.value)}
            label="Image URL"
            placeholder="https://example.com/image.jpg"
            sx={{ 
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#9c27b0',
                }
              }
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ py: 1, px: 2, gap: 1, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'grey.50' }}>
        <Button 
          onClick={onCancel}
          variant="outlined"
          startIcon={<CancelIcon />}
          sx={{ 
            fontSize: '0.75rem',
            py: 0.5,
            px: 1.5
          }}
        >
          Cancel
        </Button>
        <Button 
          type="submit"
          form="brand-form"
          variant="contained" 
          disabled={loading}
          startIcon={selected ? <EditIcon /> : <AddIcon />}
          sx={{ 
            bgcolor: '#f57c00',
            fontSize: '0.75rem',
            py: 0.5,
            px: 1.5,
            '&:hover': {
              bgcolor: '#e65100'
            }
          }}
        >
          {selected ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </>
  );
};

export default BrandForm;
